import * as React from 'react';
import cx from 'classnames';
import { ITableSubfieldComponent } from '../types';

import './text-field.styles.scss';

export type TextFieldProps = ITableSubfieldComponent<string> & {
  style?: React.CSSProperties;
  type?: 'text' | 'date';
  editable?: boolean;
};

export const TextField: React.FC<TextFieldProps> = ({ value, defaultValue, onChange, style, validate, type, editable = true }) => {
  const [localValue, setLocalValue] = React.useState(value ?? defaultValue ?? '');
  const [isFocused, setIsFocused] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (localValue !== value) {
      setLocalValue(value ?? '');
    }
  }, [value]);

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!editable) {
      return;
    }
    if (validate && !validate(e.target.value)) {
      return;
    }

    setLocalValue(e.target.value);
  }, [validate, editable]);

  const handleFocus = React.useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleBlur = React.useCallback(() => {
    setIsFocused(false);
    if (containerRef.current) {
      containerRef.current.style.width = '100%';
      containerRef.current.style.height = '100%';
    }
    if (editable) {
      onChange(localValue);
    }
  }, [localValue, onChange, editable]);

  return (
    <div
      ref={containerRef}
      className={cx('DatasheetsResultDatasheetTableFieldRowTextField', {
        'DatasheetsResultDatasheetTableFieldRowTextField--resizable': isFocused,
      })}
      style={{ width: '100%', height: '100%' }}
    >
      <textarea
        className="DatasheetsResultDatasheetTableFieldRowTextField__input"
        value={localValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={!editable}
        readOnly={!editable}
        style={style}
        rows={1}
      />
    </div>
  );
};